import { Box, Typography } from "@avenue-8/sidekick-ui";
import { TeamBrandingSectionView } from "@cma/presentation-generation-logic/models/section-view";
import { textFormatter } from "@shared/utils/text-formatter";
import LanguageIcon from "@mui/icons-material/Language";
import { PresentationSectionViewProps } from "../PresentationSectionProps";
import {
  ContactInfoItem,
  TeamCard,
  TeamLogoContainer,
  Text,
} from "./TeamBranding.styles";

interface Props extends PresentationSectionViewProps<TeamBrandingSectionView> {
  displayMode: "mobile" | "desktop" | "print" | "tablet";
}

export const TeamBrandingView = (props: Props) => {
  const { sectionView } = props;
  const { id, name, logo, website, preferences } = sectionView;
  const { showWebsite } = preferences || {};

  const clickableUrl = textFormatter.formatClickableUrl(website ?? null);
  const prettyUrl = textFormatter.formatPrettyUrl(website ?? null);

  return (
    <Box id={id} py={3} px={3} mt={3} textAlign="center">
      <TeamCard>
        {logo && (
          <TeamLogoContainer>
            <img src={logo} alt={name ?? ""} />
          </TeamLogoContainer>
        )}

        <ContactInfoItem>
          <Typography variant="h4">{name}</Typography>
        </ContactInfoItem>
        {showWebsite && clickableUrl && prettyUrl && (
          <Text>
            <LanguageIcon fontSize="small" />{" "}
            <a href={clickableUrl} target="_blank" rel="noreferrer">
              {prettyUrl}
            </a>
          </Text>
        )}
      </TeamCard>
    </Box>
  );
};
